export const DECAGON_SCRIPT_URL = "https://decagon.ai/loaders/faire.js";

export enum DecagonHandoffTags {
  BrandFaireDirectWidgetChat = "brand_fairedirect_fairedirectwidgetchat",
}
